/* SUNKISSED — Live stock line (loaded, deferred, by sections/sk-pdp-stock.liquid) */
(function () {
  'use strict';
  var cfg = document.querySelector('[data-pdp-stock]');
  var line = document.querySelector('.buybox .stock-line, .stock-line');
  var form = document.getElementById('product-form');
  var idInput = form && form.querySelector('[name="id"]');
  var addBtn = form && form.querySelector('[name="add"]');
  if (!cfg || !line || !idInput) return;

  var LOW = parseInt(cfg.getAttribute('data-low'), 10) || 3;
  var T = {
    inStock: cfg.getAttribute('data-t-instock') || 'In stock',
    low: cfg.getAttribute('data-t-low') || 'Only [count] left',
    out: cfg.getAttribute('data-t-out') || 'Sold out',
    inBag: cfg.getAttribute('data-t-inbag') || '',
    allInBag: cfg.getAttribute('data-t-allinbag') || ''
  };

  var inBag = {};      /* variant id -> quantity already in the cart */
  function inventory(vid) {
    var m = window.skVariantMax || {};
    var v = m[vid];
    return (typeof v === 'number') ? v : Infinity;   /* untracked stock: no number to show */
  }
  function remaining(vid) {
    var inv = inventory(vid);
    if (inv === Infinity) return Infinity;
    return Math.max(0, inv - (inBag[vid] || 0));
  }

  /* Shared with the sticky product bar so both say the same thing */
  window.skStock = {
    low: LOW,
    remaining: remaining,
    inventory: inventory,
    inBag: function (vid) { return inBag[vid] || 0; },
    texts: T
  };

  /* keep the theme's dot, replace only the text */
  var textEl = line.querySelector('span:not(.dot)');
  if (!textEl) { textEl = document.createElement('span'); line.appendChild(textEl); }

  function render() {
    var vid = String(idInput.value);
    var rem = remaining(vid);
    var inv = inventory(vid);
    var bag = inBag[vid] || 0;
    var avail = window.__skVarAvail !== false;
    line.classList.remove('is-low', 'is-out');
    var html;
    if (!avail || rem === 0) {
      line.classList.add('is-out');
      html = (bag > 0 && inv !== Infinity && T.allInBag) ? esc(T.allInBag.replace('[count]', inv)) : esc(T.out);
    } else if (rem !== Infinity && rem <= LOW) {
      line.classList.add('is-low');
      html = esc(T.low.replace('[count]', rem));
      if (bag > 0 && T.inBag) html += ' <span class="sk-stock-note">\u00b7 ' + esc(T.inBag.replace('[count]', bag)) + '</span>';
    } else {
      html = esc(T.inStock);
    }
    if (textEl.innerHTML !== html) textEl.innerHTML = html;
    document.dispatchEvent(new CustomEvent('sk:stock', { detail: { id: vid, remaining: rem } }));
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inBag = {};
        (c.items || []).forEach(function (it) { var k = String(it.variant_id); inBag[k] = (inBag[k] || 0) + it.quantity; });
        render();
      })
      .catch(function () { render(); });
  }

  /* The theme changes the variant without firing an event, but it always re-runs its own button
     logic (text / disabled) afterwards: watching the button is the reliable trigger. */
  if (addBtn && 'MutationObserver' in window) {
    new MutationObserver(function () { render(); }).observe(addBtn, { attributes: true, childList: true, characterData: true, subtree: true });
  }
  var buybox = document.querySelector('.buybox') || form;
  ['click', 'change'].forEach(function (ev) { buybox.addEventListener(ev, function () { setTimeout(render, 60); setTimeout(render, 350); }); });

  /* Bag changed (added from this page, drawer +/- or remove): the header count is updated by the
     theme every time. Re-read the bag here AND ask the theme to re-read its own copy, so the main
     button (which the theme controls) comes back from "Out of stock" after a removal. */
  var count = document.querySelector('[data-cart-count]');
  if (count && 'MutationObserver' in window) {
    new MutationObserver(function () {
      refreshCart();
      if (typeof window.skRefreshCartQty === 'function') window.skRefreshCartQty();
    }).observe(count, { childList: true, characterData: true, subtree: true });
  }

  render();
  refreshCart();
})();
